import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { CheckItem } from '../CheckItem';
import { ProductImage } from '../ProductImage';
import { offerIncludes, PRICE } from '../../data/salesContent';
export function OfferSection() {
  return <section id="oferta" className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-158" data-mp="ajbdgo8l2dgy">
      <div className="mx-auto max-w-5xl" data-id="element-159" data-mp="al5w1vwdtthv">
        <SectionHeading title="Elegí empezar con todo organizado" data-id="element-160" data-mp="6i9msvsqf9ql" />
        <div className="mx-auto mt-14 max-w-xl rounded-3xl border-2 border-gold bg-ink p-7 shadow-[0_20px_60px_rgba(212,175,55,0.12)] md:p-10" data-id="element-161" data-mp="1qhr66upydtl">
          <div className="text-center" data-id="element-162" data-mp="3sxkn1bli58a5">
            <p className="font-display text-2xl font-black uppercase tracking-wide text-gold md:text-3xl" data-id="element-163" data-mp="3sug75gyoco3n">Sistema completo</p>
            <p className="mt-2 text-lg font-semibold text-cream md:text-xl" data-id="element-164" data-mp="3iz4r8vbj5aub">Primeros Auxilios para Instructores™</p>
            <p className="mt-1 text-base text-neutral-400 md:text-lg" data-id="element-165" data-mp="3ey2rmddpawrt">3 volúmenes + 5 bonos</p>
          </div>
          <ProductImage className="mx-auto mt-6 max-w-sm" data-id="element-166" data-mp="1ar8r0qv4tj95" />
          <div className="my-8 h-px bg-gold/30" aria-hidden="true" data-id="element-167" data-mp="1fih17p4ad8nd" />
          <div className="text-center" data-id="element-168" data-mp="1fktqkncdilag">
            <p className="font-display text-6xl font-black text-gold md:text-7xl" data-id="element-169" data-mp="10ucqb7bh61f5">{PRICE}</p>
            <p className="mt-4 text-sm font-bold uppercase tracking-[0.2em] text-cream md:text-base" data-id="element-170" data-mp="15snyldm4g3v9">Pago único</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-[0.2em] text-cream md:text-base" data-id="element-171" data-mp="1ti8mmax4trbe">Acceso digital inmediato</p>
          </div>
          <p className="mt-8 text-sm font-bold uppercase tracking-wider text-neutral-500" data-id="element-172" data-mp="1yfijgbmup599">Incluye:</p>
          <ul className="mt-3 space-y-3" data-id="element-173" data-mp="1kjwn1jeafj6t">
            {offerIncludes.map(i => <CheckItem key={i} className="text-lg text-cream" data-id="element-174" data-mp="1ohue6rrmcfcu">
                {i}
              </CheckItem>)}
          </ul>
          <div className="mt-8" data-id="element-175" data-mp="d49ymsbh2xh2">
            <CtaButton data-id="element-176" data-mp="d5bcf4jvhy2h">Quiero el sistema completo</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}